// extracted by mini-css-extract-plugin
export var layout = "Layout-module--layout--RFO+s";
export var navModal = "Layout-module--navModal--hqgHn";
export var nonHeader = "Layout-module--nonHeader--JQ7f9";
export var pageBody = "Layout-module--pageBody--iOkc4";